<script setup>
  import MapButton from '@/components/MapButton.vue';
  import Icon from '@/components/icons/Icon.vue';

  import useSettingsGlobals from '@/composables/useSettingsGlobals';
  import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();  
  const { $DETAIL_PANEL } = useMapConfigurationGlobals();  

  // TODO: Composable
  function emitEvent(event) {
    window.$EventBus.dispatchEvent(event);
  }  

  function controlsClickHandler(e) {
    const clickedButton = e.target.closest('[data-action]');

    if (!clickedButton) return;

    const action = clickedButton.dataset.action;

    switch(action) {
      case 'right-panel':
        emitEvent('right-panel-open');
        break;
      case 'storm-panel':
        emitEvent('storm-panel-open');
        break;
    }
  }
</script>

<template>
  <div @click.prevent="controlsClickHandler" class="map__controls jwx-map__controls--secondary">
    <div class="jwx-map-block jwx-map-block--transparent-border">
      <ul class="jwx-map-block__content jwx-map-block__items">
        <li
          v-if="!$WEB_VIEW && $DETAIL_PANEL"
          class="jwx-map-block__item"
        >
          <MapButton
            data-action="right-panel"
          >
            <Icon name="graph" class="jwx-map-button__icon" />  
          </MapButton>
        </li>
      </ul>
    </div>
  </div>
</template>